module.exports = __webpack_public_path__ + "resources/img/img_watchall_sms2_en.d1533d35ba9cebb2a3b31ac5300fd68b.png";